<template>
  <Expansion
    :value="value"
    v-bind="{
      title, hideIcon, hideLine, light, duration,
    }"
    @input="$emit('input', $event)"
  >
    <template #header>
      <slot name="header" />
    </template>
    <div class="expansion-content">
      <slot />
    </div>
  </Expansion>
</template>

<script>
export default {
  name: 'CustomExpansion',
  props: {
    filled: {
      type: [Boolean, String],
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
    hideLine: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
    duration: {
      type: Number,
      default: 0.575,
    },
  },
  computed: {
    fillColor() {
      return _.isBoolean(this.filled)
        ? 'var(--base-input--filled-color-base)'
        : _.isString(this.filled)
          ? this.filled.includes('#')
            ? this.filled
            : `var(--${this.filled})`
          : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.expansion {
  background-color: v-bind(fillColor);
  border-radius: 5px;

  :deep(.expansion__title) {
    padding: 1rem 1.875rem;

    + div {
      padding: 0;
    }

    > div:nth-child(1) {
      color: #000;
    }
  }

  .expansion-content {
    border-top: 1px solid #fff;
    padding: 1.875rem;
  }
}
</style>
